<template>
	<div class="posts">
		<content-container :not-found="notFound">
			
		</content-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				posts: [],
				notFound: false
			};
		},
		methods: {
			async load() {
				this.$store.state.loading++;
				try {
					const data = await this.$get('/json/posts');
					this.posts = data.posts;
				} catch(e) {
					this.notFound = e.code === 404;
				}
				this.$store.state.loading--;
			}
		},
		async mounted() {
			await this.load();
		}
	}
</script>